import { types as sdkTypes } from './sdkLoader';
import { LINE_ITEM_OFFER, LINE_ITEM_REQUEST, LISTING_UNIT_TYPES } from './types';

const parseInteger = value => {
  if (Number.isInteger(value)) {
    return value;
  }
  const parsed = Number.parseInt(value, 10);
  return Number.isInteger(parsed) ? parsed : null;
};

export const getOrderOfferParams = orderData => {
  return orderData?.offerParams || orderData?.protectedData?.offerParams || null;
};

export const getTransactionUnitLineItem = transaction => {
  const lineItems = transaction?.attributes?.lineItems || [];
  return lineItems.find(item => LISTING_UNIT_TYPES.includes(item.code) && !item.reversal) || null;
};

export const getTransactionNegotiationLineItem = transaction => {
  const lineItems = transaction?.attributes?.lineItems || [];
  return (
    lineItems.find(
      item => [LINE_ITEM_REQUEST, LINE_ITEM_OFFER].includes(item.code) && !item.reversal
    ) || null
  );
};

export const getTransactionOfferQuantity = transaction => {
  const offerQuantity = parseInteger(transaction?.attributes?.protectedData?.offerParams?.quantity);
  if (offerQuantity && offerQuantity > 0) {
    return offerQuantity;
  }

  const unitLineItem = getTransactionUnitLineItem(transaction);
  const quantity = parseInteger(unitLineItem?.quantity || unitLineItem?.units);
  return quantity && quantity > 0 ? quantity : null;
};

export const getTransactionOfferPriceMoney = transaction => {
  const metadataOfferAmount = transaction?.attributes?.metadata?.currentOfferAmount;
  const metadataCurrency =
    transaction?.attributes?.payinTotal?.currency ||
    transaction?.attributes?.protectedData?.offerParams?.currency ||
    transaction?.listing?.attributes?.price?.currency;
  if (Number.isInteger(metadataOfferAmount) && metadataCurrency) {
    return new sdkTypes.Money(metadataOfferAmount, metadataCurrency);
  }

  const offerParams = transaction?.attributes?.protectedData?.offerParams || {};
  if (Number.isInteger(offerParams?.price) && offerParams?.currency) {
    return new sdkTypes.Money(offerParams.price, offerParams.currency);
  }

  const negotiationLineItem = getTransactionNegotiationLineItem(transaction);
  return negotiationLineItem?.unitPrice || null;
};

export const getTransactionGrossTotalMoney = transaction => {
  const explicitTotal = transaction?.attributes?.payinTotal || null;
  if (explicitTotal) {
    return explicitTotal;
  }

  const offerPrice = getTransactionOfferPriceMoney(transaction);
  const hasSavedOfferPrice = Number.isInteger(
    transaction?.attributes?.protectedData?.offerParams?.price
  );
  const hasMetadataOfferPrice = Number.isInteger(
    transaction?.attributes?.metadata?.currentOfferAmount
  );
  if (offerPrice && (hasSavedOfferPrice || hasMetadataOfferPrice)) {
    return offerPrice;
  }

  const negotiationLineItem = getTransactionNegotiationLineItem(transaction);
  if (negotiationLineItem?.lineTotal) {
    return negotiationLineItem.lineTotal;
  }

  return null;
};
